import BuildingDirectoryApi from '../api/routes/BuildingDirectoryApi';
import BuildingDirectory from '../pages/BuildingDirectory/models/buildingDirectory';
import BuildingDirectoryInfo from '../pages/BuildingDirectory/models/buildingDirectoryInfo';

const fetchBuildingDirectories = async (
    address?: string,
    country?: string,
    lon?: number,
    lat?: number
): Promise<BuildingDirectoryInfo[]> => {
    try {
        const response = await BuildingDirectoryApi.fetchBuildingDirectories(address, country, lon, lat);
        const items = response.data.map((x) => new BuildingDirectoryInfo(x));
        return items;
    } catch (e) {
        return [];
    }
};

const fetchBuildingDirectory = async (id: string): Promise<BuildingDirectory> => {
    const response = await BuildingDirectoryApi.fetchBuildingDirectory(id);
    return response.data as any;
};

const fetchCountries = async (): Promise<string[]> => {
    try {
        const response = await BuildingDirectoryApi.fetchCountries();
        if (response.data?.length > 0) {
            return response.data;
        }
        return [];
    } catch (e) {
        return [];
    }
};

const BuildingDirectoryService = {
    fetchBuildingDirectories,
    fetchBuildingDirectory,
    fetchCountries,
};
export default BuildingDirectoryService;
